<div class="header-container">
  <img [src]="resolvedLogo" [alt]="logoAlt" [class.logo-invert]="invertDefaultLogo" (error)="onLogoError()" />
  @if (!hasCustomLogo && defaultWordmark) {
    <div class="header-title">{{ defaultWordmark }}</div>
  }
</div>
